import { lazy } from 'react';
import { Route } from 'react-router-dom';

const MandiChat = lazy(() => import('../components/mandi-chat'));
const VideoContest = lazy(() => import('../components/video-contest'));
const VideoContest800001 = lazy(() => import('../components/video-contest-800001'));
const Stories = lazy(() => import('../components/stories'));

const contentRoutes = (
	<>
		<Route path="/mandi-chat" element={<MandiChat />} />
		<Route path="/video-contest" element={<VideoContest />} />
		<Route path="/video-contest-800001" element={<VideoContest800001 />} />
		<Route path="/stories" element={<Stories />} />
	</>
);

export default contentRoutes;
